module.exports = __webpack_public_path__ + "static/media/faqActive.6398af26.svg";